import React from 'react';
import { node, string } from 'prop-types';
import NavLink from '../../common/NavLink';

const DeNavButton = ({ icon, label, location }) => {
  const pathName = window.location.pathname;
  let navClass = 'de--nav--btn';
  if (pathName.includes(location)) {
    navClass += ' de--nav--btn--active';
  }
  return (
    <NavLink
      className={navClass}
      to={location}
      activeClassName="de--nav--btn--active"
    >
      {icon && <span className="de--nav--btn--icon">{icon}</span>}
      <span className="de--nav--btn--label">{label}</span>
    </NavLink>
  );
};

DeNavButton.propTypes = {
  icon: node,
  label: string.isRequired,
  location: string,
};

export default DeNavButton;
